export const TRANSACTION_STATUS = {
  EXCEPTION: 'Exception',
  ISSUED: 'Issued',
  PAID: 'Paid',
  RETURNED: 'Returned',
  STOP_PAYMENT: 'Stop Payment',
  VOID: 'Void'
}

export const initialTransaction = {
  accountId: "",
  accountName: "",
  accountNumber: "",
  achOriginatorID: "",
  amount: 0,
  checkNumber: 0,
  clientId: "",
  decision: null,
  decisionedBy: null,
  drcr: "",
  exception: null,
  exceptionDate: "",
  foundPayee: null,
  id: "",
  imageFound: false,
  inputDate: "",
  issuedDate: "",
  issuedPayee: "",
  notes: null,
  paidDate: null,
  payeeMatchConfidence: null,
  reason: null,
  secCode: "",
  staleDatedAsOf: null,
  status: "",
  traceNumber: "",
  transactionCode: "",
  transactionDescription: "",
  transactionType: "",
  voidDate: null
}